import * as React from "react";
import PropTypes from "prop-types";
import {
  Eye16Filled,
  Certificate16Regular,
  ListBar16Filled,
  TableSimple16Regular,
  MoreHorizontal16Regular,
  MoreVertical16Filled,
} from "@fluentui/react-icons";
import {
  Label,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemLink,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Tooltip,
  Image,
  Text,
  Link,
  tokens,
  makeStyles,
  Card,
  CardFooter,
  CardHeader,
  CardPreview,
  Button,
  typographyStyles,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  component: {
    paddingRight: tokens.spacingHorizontalM,
  },
  tools: {
    marginBottom: tokens.spacingVerticalM,
    textAlign: "right",
  },
  cards: {
    marginBottom: tokens.spacingVerticalM,
  },
  card: {
    marginBottom: tokens.spacingVerticalM,
  },
  cardPreview: {
    paddingLeft: tokens.spacingVerticalM,
    paddingRight: tokens.spacingVerticalM,
  },
  toolsButton: {
    marginLeft: tokens.spacingHorizontalSNudge,
  },
  label: {
    display: "block",
    color: tokens.colorBrandStroke1,
    fontWeight: tokens.fontWeightBold,
  },
  text: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    marginRight: tokens.spacingHorizontalSNudge,
  },
  textStrong: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightBold,
  },
  textBlock: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    display: "block",
  },
  textLink: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
  },
  textLinkStrong: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightBold,
  },
});

const Warranty = (props) => {
  const { data, domain, loading } = props;
  const styles = useStyles();

  return (
    <section className={styles.component}>
      {loading == false ? (
        data && data.length ? (
          <div className={styles.cards}>
            {data.map((warranty) => {
              return (
                <Card className={styles.card} key={warranty.Warranty.id}>
                  <CardHeader
                    header={
                      <Link
                        href={`${domain}/admin/warranties/view/${warranty.Warranty.id}`}
                        target="_blank"
                        className={styles.textLinkStrong}
                      >
                        #{warranty.Warranty.id}
                      </Link>
                    }
                    action={
                      <div>
                        <Text className={styles.text}>{new Date(warranty.Warranty.created).toLocaleString()}</Text>
                        <Menu>
                          <MenuTrigger disableButtonEnhancement>
                            <MenuButton icon={<MoreVertical16Filled />} size="small" appearance="transparent" />
                          </MenuTrigger>
                          <MenuPopover>
                            <MenuList>
                              <MenuItemLink
                                icon={<Eye16Filled />}
                                href={`${domain}/admin/warranties/view/${warranty.Warranty.id}`}
                                target="_blank"
                              >
                                View
                              </MenuItemLink>
                            </MenuList>
                          </MenuPopover>
                        </Menu>
                      </div>
                    }
                  />
                  <CardPreview className={styles.cardPreview}>
                    <div>
                      <Text className={styles.textStrong}>{warranty.Warranty.item}</Text>
                    </div>
                    {warranty.Warranty.message != "" && (
                      <div>
                        <Text className={styles.text}>{warranty.Warranty.message}</Text>
                      </div>
                    )}
                  </CardPreview>
                  <CardFooter>
                    {warranty.Warranty.order_no != "" && (
                      <div>
                        <Label size="small" weight="semibold" className={styles.label}>
                          Order ID
                        </Label>
                        <Link
                          href={`${domain}/admin/orders/view/${warranty.Warranty.order_no}`}
                          target="_blank"
                          className={styles.textLink}
                        >
                          #{warranty.Warranty.order_no}
                        </Link>
                      </div>
                    )}
                  </CardFooter>
                </Card>
              );
            })}
          </div>
        ) : (
          <Text>No warranty found</Text>
        )
      ) : (
        <Text>Loading...</Text>
      )}
    </section>
  );
};

Warranty.propTypes = {
  query: PropTypes.object,
};

export default Warranty;
